// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-portia[data-v-5e7d7ccc]{display:inline-block;-o-object-fit:cover;object-fit:cover;border-radius:50%}", ""]);
// Exports
module.exports = exports;
